import React, { useEffect } from "react";

import { DataGrid, GridColDef, GridEventListener, GridRowParams, GridValueGetterParams } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

import { useStoreDispatch, useStoreSelector, useTableSelector } from "../../store/Hooks";
import Anchor from "../../models/anchors/Anchor";
import { postgrest_operators } from "../../helpers/HttpHelper";
import { navSliceActions } from "../../store/slices/NavSlice";
import Button from "@mui/material/Button";
import store from "../../store/Store";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Tooltip from "@mui/material/Tooltip";


const columns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 130 },
  { field: "subject_id", headerName: "PatientID", width: 130 },
  { field: "interaction_id", headerName: "PathwayID", width: 130 },
  { field: "active", headerName: "Active", width: 130 },
  { field: "final", headerName: "Final", width: 130 },
  { field: "self_reported", headerName: "Self Reported", width: 130 },
  { field: "date", headerName: "Anchor Date", width: 130 },
  { field: "time", headerName: "Anchor Time", width: 130 },
  {
    field: "properties",
    headerName: "Properties",
    sortable: false,
    flex: 1,
    valueGetter: (params: GridValueGetterParams) => {
      // Check if properties exist and is a Map
      if (params.row.properties && typeof params.row.properties.toJSObject === 'function') {
        return JSON.stringify(params.row.properties.toJSObject());
      } else {
        // Return a default or error message if properties is not set or not as expected
        return "No properties";
      }
    },
  },
  {
    field: "actions",
    headerName: "Actions",
    sortable: false,
    width: 150,
    renderCell: (params) => (
      <span>
        {/* edit anchor button */}
        <Tooltip title="Edit Anchor">
          <Button
            variant="contained"
            color="warning"
            onClick={(event) => {
              event.stopPropagation()
              store.dispatch(
                navSliceActions.openRightDrawer({
                  type: "anchor",
                  resourceID: params.row.id,
                }),
              );
            }}
          >
            <ModeEditIcon />
          </Button>
        </Tooltip>
        &nbsp;
        {/* interaction schedule button */}
        <Tooltip title="View Interaction Schedule">
          <Button
            variant="contained"
            color="primary"
            onClick={(event) => {
              event.stopPropagation()
              const anchor = params.row;
              store.dispatch(
                navSliceActions.openRightDrawer({
                  content: anchor,
                  type: "interaction_schedule"
                }),
              );

            }}
          >
            <CalendarMonthIcon />
          </Button>
        </Tooltip>
      </span>
    ),
  },

];

const AnchorTable = () => {
  const anchors = useTableSelector(Anchor);

  // const handleRowClick: GridEventListener<"rowClick"> = (params: GridRowParams) => {
  //   const anchor = params.row;
  //   dispatch(
  //     navSliceActions.openRightDrawer({
  //       content: anchor,
  //       type: "interaction_schedule"
  //     }),
  //   );
  // };

  const interaction_id = useStoreSelector(
    (state) => state.interactionTree.RootInteractionID,
  );

  useEffect(() => {
    Anchor.queryTable([
      {
        column: "interaction_id",
        operator: postgrest_operators.eq,
        value: interaction_id.toString(),
      },
    ]);
  }, []);

  return (
    <Box sx={{ padding: "10px" }}>
      <DataGrid
        rows={anchors.toArray()}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { page: 0, pageSize: 10 } },
        }}
      // onRowClick={handleRowClick}
      // sx={{
      //   '& .MuiDataGrid-row:hover': {
      //     cursor: 'pointer',
      //   },
      // }}
      />
    </Box>
  );
};

export default AnchorTable;
